<template>
    <div class="bg-dim flex-col">
        <div>
            <div class="productCards-wrap">
                <strong>원하는 디자인을 선택해주세요.</strong>
                <div class="card-box">
                    <span>고맙습니다.</span>
                    <div class="cheering-centerTest"></div>
                </div>
                <div class="card-box">
                    <span>응원합니다.</span>
                    <div class="cheering-center"></div>
                </div>
                <div class="card-box">
                    <span>생일 축하해요.</span>
                    <div class="cake-center shadow"></div>
                </div>
                <button class="button-bg-gray border-left-round" @click="modalClose(false)">취소</button>
                <button class="button-bg-yellow border-right-round" @click="modalClose(true)">선택완료</button>
            </div>
        </div>
    </div>
</template>

<script>
import BottomButton from '@/components/common/BottomButton.vue';
export default {
    name: 'ProductCards',
    components: {BottomButton},
    data() {
        return  {
        }
    },
    methods : {
      /**
       * 카드 이미지 선택 모달을 닫는 함수
       * @param {Boolean} flag
       */
      modalClose(flag) {
        if(!flag){
          this.$emit('')
        }
      }
    }
};
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/common/productCards.scss';

  .cheering-centerTest
  {background-image: url("https://mycloudmembership-dev.s3.ap-northeast-2.amazonaws.com/emarticon/public/img/emarticon_image3.png");
    background-repeat: no-repeat;
    background-position:center;
    background-size: cover;}
</style>